import {
  type BannerV2,
  type BannerV3,
  type BannerResponse,
  type BannerV3Response,
} from 'api/definitions/adtech/types';
import createReducer from 'redux/createReducer';
import {
  ADTECH_BANNERS,
  ADTECH_LEADERBOARD,
  ADTECH_OFFERS,
  ADTECH_OFFERS_LEADERBOARDS,
} from '../actions/types';

import initialState from './initial-state';

type searchTerm = string;
export type BannersByCategory = BannerResponse['bannerAds'];

export type BannersState = {
  byCategory: BannerResponse['bannerAds'];
  bySearchTerm: Record<searchTerm, BannerV2>;
  offers: {
    hotspots: BannerV3[];
    leaderboards: BannerV2[];
  };
};

type BannersSuccessAction = {
  result: BannerResponse;
};

type leaderboardSuccessAction = {
  searchTerm: string;
  result: { payload: BannerV3Response };
};

type offersSuccessAction = {
  result: { payload: BannerV3Response };
};

const bannerSuccess = (state: BannersState, action: BannersSuccessAction) => {
  return {
    ...state,
    byCategory: {
      ...state.byCategory,
      ...action.result.bannerAds,
    },
  };
};

// TODO add support for leaderboard to TradingCell WPIP-79805
const tempTradingCellProps = {
  gridPosition: 0,
};

const leaderboardSuccess = (state: BannersState, action: leaderboardSuccessAction) => {
  const result = action.result.payload?.bannerAds?.[0];
  return result
    ? {
        ...state,
        bySearchTerm: {
          ...state.bySearchTerm,
          [action.searchTerm]: {
            ...tempTradingCellProps,
            ...result,
            marketingBadge: '',
          },
        },
      }
    : state;
};

const offersSuccess = (state: BannersState, action: offersSuccessAction) => {
  return {
    ...state,
    offers: {
      ...state.offers,
      hotspots: action.result.payload.bannerAds,
    },
  };
};

const offersLeaderboardsSuccess = (state: BannersState, action: offersSuccessAction) => {
  return {
    ...state,
    offers: {
      ...state.offers,
      leaderboards: action.result.payload.bannerAds.map(banner => ({
        ...banner,
        marketingBadge: '',
      })),
    },
  };
};

const actionTypeReducerMap = [
  [ADTECH_BANNERS.success, bannerSuccess],
  [ADTECH_LEADERBOARD.success, leaderboardSuccess],
  [ADTECH_OFFERS.success, offersSuccess],
  [ADTECH_OFFERS_LEADERBOARDS.success, offersLeaderboardsSuccess],
] as const;

export default createReducer(initialState, actionTypeReducerMap);
